export default __webpack_public_path__ + "static/media/signature.bcff2e6b.svg";